import { apiClient, ApiError } from "./apiClient";
import type {
  CreateBlogPostRequestDto,
  CreateBlogPostResponseDto,
  DeleteBlogPostResponseDto,
  GetBlogPostDetailResponseDto,
  GetBlogPostListParams,
  GetBlogPostListResponseDto,
  UpdateBlogPostRequestDto,
  UpdateBlogPostResponseDto,
} from "../types/api/blog-post";

/** 공개 블로그 조회 시 Bearer 없이 호출할지 (만료 토큰·비로그인 시 401 방지) */
export type BlogPostReadOptions = {
  skipAuth?: boolean;
};

export const getBlogPostList = async (
  params: GetBlogPostListParams,
  options?: BlogPostReadOptions,
): Promise<GetBlogPostListResponseDto> => {
  try {
    const response = await apiClient.get<GetBlogPostListResponseDto>(
      `/blog-post/list`,
      {
        params,
        skipAuth: options?.skipAuth === true,
      },
    );
    return response;
  } catch (error) {
    if (error instanceof ApiError) {
      throw new Error(
        error.message || "블로그 목록을 불러오는데 실패했습니다.",
      );
    }
    throw error;
  }
};

export const getBlogPostDetail = async (
  blogPostId: number,
  language?: string,
  options?: BlogPostReadOptions,
): Promise<GetBlogPostDetailResponseDto> => {
  try {
    const response = await apiClient.get<GetBlogPostDetailResponseDto>(
      `/blog-post/${blogPostId}/detail`,
      {
        params: language ? { language } : {},
        skipAuth: options?.skipAuth === true,
      },
    );
    return response;
  } catch (error) {
    if (error instanceof ApiError) {
      throw new Error(
        error.message || "블로그 상세를 불러오는데 실패했습니다.",
      );
    }
    throw error;
  }
};

export const createBlogPost = async (
  data: CreateBlogPostRequestDto,
): Promise<CreateBlogPostResponseDto> => {
  try {
    return await apiClient.post<CreateBlogPostResponseDto>(`/blog-post`, data);
  } catch (error) {
    if (error instanceof ApiError) {
      throw new Error(error.message || "블로그 등록에 실패했습니다.");
    }
    throw error;
  }
};

export const updateBlogPost = async (
  blogPostId: number,
  data: UpdateBlogPostRequestDto,
): Promise<UpdateBlogPostResponseDto> => {
  try {
    return await apiClient.patch<UpdateBlogPostResponseDto>(
      `/blog-post/${blogPostId}`,
      data,
    );
  } catch (error) {
    if (error instanceof ApiError) {
      throw new Error(error.message || "블로그 수정에 실패했습니다.");
    }
    throw error;
  }
};

export const deleteBlogPost = async (
  blogPostId: number,
): Promise<DeleteBlogPostResponseDto> => {
  try {
    return await apiClient.delete<DeleteBlogPostResponseDto>(
      `/blog-post/${blogPostId}`,
    );
  } catch (error) {
    if (error instanceof ApiError) {
      throw new Error(error.message || "블로그 삭제에 실패했습니다.");
    }
    throw error;
  }
};
